import { captureException } from '@sentry/react';

import { isApiServiceError } from '@/services/http/errors';
import { toast } from '@/shared/components/toasts/PlatformToast';

interface AlertMutationFailureOptions {
    fallbackMessage: string;
    operation: 'create' | 'delete' | 'update';
}

export const reportAlertMutationFailure = (
    error: unknown,
    { fallbackMessage, operation }: AlertMutationFailureOptions,
): void => {
    if (isApiServiceError(error) && error.code === 'CONFLICT') {
        toast.warning(error.message);
        return;
    }

    if (!isApiServiceError(error) || !['VALIDATION_ERROR', 'FORBIDDEN', 'NOT_FOUND'].includes(error.code)) {
        captureException(error, { tags: { operation: `workspace-alert.${operation}` } });
    }

    toast.error(isApiServiceError(error) ? error.message : fallbackMessage);
};
